module.exports = __webpack_public_path__ + "img/money-bill-1-wave.f66c084c.svg";